import { render, staticRenderFns } from "./frame03.vue?vue&type=template&id=662159f0&scoped=true&"
import script from "./frame03.vue?vue&type=script&lang=js&"
export * from "./frame03.vue?vue&type=script&lang=js&"
import style0 from "./frame03.vue?vue&type=style&index=0&id=662159f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662159f0",
  null
  
)

export default component.exports